import { render, staticRenderFns } from "./Gestor.vue?vue&type=template&id=25436a52&scoped=true&"
import script from "./Gestor.vue?vue&type=script&lang=js&"
export * from "./Gestor.vue?vue&type=script&lang=js&"
import style0 from "./Gestor.vue?vue&type=style&index=0&id=25436a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25436a52",
  null
  
)

export default component.exports